// extracted by mini-css-extract-plugin
module.exports = {"headerTextFirstLine":"index_headerTextFirstLine__3GO4J","headerTextSecondLine":"index_headerTextSecondLine__3BlfR","fatFont":"index_fatFont__3-zZm"};